export const SurveysActionTypes = {
  API_RESPONSE_SUCCESS: '@@survey/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@survey/API_RESPONSE_ERROR',

  GET_SURVEY: '@@survey/GET_SURVEY',
  LIST_SURVEYS: '@@survey/LIST_SURVEYS',
  ADD_SURVEY: '@@survey/ADD_SURVEY',
  DUPLICATE_SURVEY: '@@survey/DUPLICATE_SURVEY',
  UPDATE_SURVEY: '@@survey/UPDATE_SURVEY',
  DELETE_SURVEY: '@@survey/DELETE_SURVEY',

  RESET: '@@survey/RESET'
}
